<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />

    <template v-if="true">
      <div class="text__view flex flex-col justify-center text-center mb-5">
        <h1 class="font-semibold text-2xl my-5">
          {{ ugc_creator_title_subtitle.title }}
        </h1>
        <p class="leading-6 max-w-5xl mx-auto">
          {{ ugc_creator_title_subtitle.subtitle }}
        </p>
      </div>

      <Filters :active_filters="{
        search: true,
        ugc_country: true,
        industry: true,
        gender: true,
      }" :placeholder="'Search by name'" :origin="'ugccreators'"
        class="hidden xl:grid grid-cols-8 grid-flow-col justify-center items-center" />
      <template v-if="ugc_creators && ugc_creators.length">
        <div class="library__list py-4 lg:py-10 items-start">
          <UgcCreator v-for="ugc in ugc_creators" :key="ugc.id" :data="ugc" class="library__item" :isCollection="false" />
        </div>
      </template>
      <template v-else>
        <div class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto">
          <div>
            <h2 class="text-4xl font-semibold mb-4">
              Looking for FB, IG and TIKTOK ads 👀
            </h2>
            <p class="mb-10 text-lg">
              We recommend to clean the filters
            </p>
            <div class="flex justify-center">
              <Button @click="getInitialAds()" class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white">Clean
                filters</Button>
            </div>
          </div>
        </div>
      </template>
    </template>
    <Pagination :totalElements="totalUgcCreators" :pageView="page" nameView="UgcCreators" />
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import UgcCreator from "@/components/UgcCreator/index";
import Button from "@/components/UI/Button";
import Filters from "@/components/Filters";
import Pagination from "@/components/Pagination";
import { useRouter } from "vue-router";

export default {
  components: {
    HeaderApp,
    UgcCreator,
    AdblockTopbar,
    Button,
    Pagination,
    Filters,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
        console.log("1")

        router.push("/pricing");
      } else {
        await store.dispatch("GET_UGC_CREATORS");
      }
    });

    const ugc_creators = computed(() => store.state.ugcCreators);
    const totalUgcCreators = computed(() => store.state.totalUgcCreators);
    const page = computed(() => store.state.pageUgcCreators);
    const roleUser = computed(() => store.state.role);
    const ugc_creator_title_subtitle = computed(
      () => store.state.ugcCreatorsTitleSubtitle
    );
    const getInitialAds = () => {
      store.commit("CLEAN_FILTERS");
    };

    return {
      ugc_creators,
      roleUser,
      totalUgcCreators,
      page,
      ugc_creator_title_subtitle,
      getInitialAds,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}

.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
